import { Injectable } from '@angular/core';
import { BffCommunicationService } from '../../core/services/bff-communication.service';
import { Observable } from 'rxjs';
import { Localisation } from '../modeles/localisation.modele';
import { FeatureToggleService } from '../../core/services/feature-toggle.service';
import { HttpParams } from '@angular/common/http';
import { MPM_RENDEZVOUS_LOCALISATION } from '../../../configs/toggles.config';

@Injectable({
  providedIn: 'root'
})
export class LocalisationRepresentantApiService {
  constructor(
    private readonly _bffApiService: BffCommunicationService,
    private readonly _featureToggleService: FeatureToggleService
  ) {}

  getLocalisations(): Observable<Localisation[]> {
    if (this._featureToggleService.hasFeatures(MPM_RENDEZVOUS_LOCALISATION.ServiceRepresentant)) {
      return this._bffApiService.getJSONBFF(`/api/v1/localisations`) as Observable<Localisation[]>;
    } else {
      return new Observable();
    }
  }

  getLocalisationRepresentant(idDeveloppeur: string): Observable<Localisation> {
    if (this._featureToggleService.hasFeatures(MPM_RENDEZVOUS_LOCALISATION.ServiceRepresentant)) {
      const params: HttpParams = new HttpParams({
        fromObject: {
          idDeveloppeur
        }
      });

      return this._bffApiService.getJSONBFFParams(`/api/v1/localisations`, params) as Observable<Localisation>;
    } else {
      return new Observable();
    }
  }
}
